import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FieldInfoIconComponent } from './field-info-icon.component';

@NgModule({
  declarations: [FieldInfoIconComponent],
  exports: [FieldInfoIconComponent],
  imports: [CommonModule]
})
export class FieldInfoIconModule { }
